import React, { useEffect, useState } from 'react';
import Layout from '../Layout';
import { Typography, Container, Box, Grid, Popover } from '@material-ui/core';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PowerIcon from '@material-ui/icons/Power';
import WbIncandescentIcon from '@material-ui/icons/WbIncandescent';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ShowChartIcon from '@material-ui/icons/ShowChart';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import AssignmentIcon from '@material-ui/icons/Assignment';
import "./Breakdown.css";
import { useNavigate } from 'react-router-dom';
import CustomBreadcrumbs from '../Breadcrumb';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useDispatch } from 'react-redux';
import { GridLoadingSpinner } from '@tmlconnected/avant-garde-components-library';
import { getBDStatus, getBreakdowns } from '../../ReduxStore/Breakdown/BreakdownSlice';

const Breakdown = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const breadcrumbsLinks = [
        { label: 'Home', href: '/' }
    ];


    const [loading, setLoading] = useState(true);
    const [allEvents, setAllEvents] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedEvent, setSelectedEvent] = useState(null)

    const handleEventClick = (info) => {
        // Prevent the default click behavior
        info.jsEvent.preventDefault();

        // Set the selected event and open the popover
        setSelectedEvent(info.event);
        setAnchorEl(info.jsEvent.currentTarget);
    };

    const handleClosePopover = () => {
        setAnchorEl(null);
        setSelectedEvent(null);
    };

    const handler = (route) => {
        navigate(route)
    }


    // const [events, setEvents] = useState([
    //     {
    //         title: 'Event 1',
    //         start: '2024-09-20',
    //         end: '2024-09-22',
    //     },
    //     {
    //         title: 'Event 2',
    //         start: '2024-09-25T10:00:00',
    //         end: '2024-09-25T12:00:00',
    //     },
    // ]);

    // const handleDateClick = (info) => {
    //     alert('Date clicked: ' + info.dateStr);
    // };

    // const handleEventClick = (info) => {
    //     alert('Event clicked: ' + info.event.title);
    // };

    const getBreakDowns = async (id) => {
        try {
            const action = dispatch(getBreakdowns(`?status_id=${id}`));
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {
                // Map the response to create an array of events
                const events = res.result.breakdowns.map(breakdown => ({
                    title: breakdown.machine_details.asset_text || "No Title",
                    start: breakdown.reported_at,
                    extendedProps: {
                        asset_no: breakdown.machine_details.asset_no,
                        details: breakdown.details,
                    },
                }));
                setAllEvents(events);
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
            // toast.info(error.message || "Something went wrong!");
        }
    };


    const getStatus = async () => {
        try {
            const action = dispatch(getBDStatus());
            const res = await action.unwrap();
            console.log("res", res.result)
            if (res.result) {

                // Find the id for status "reported"
                const reportStatus = res.result.bd_status.find(item => item.status === "reported");
                const reportStatusId = reportStatus ? reportStatus.id : null;

                // Find the id for status "under-maintenance"
                const mainStatus = res.result.bd_status.find(item => item.status === "under-maintenance");
                const mainStatusId = mainStatus ? mainStatus.id : null;
                // setBDStatus(mainStatusId)

                if (reportStatusId) {
                    // await getBreakDowns(reportStatusId)
                    await getBreakDowns(mainStatusId)
                }
            }
        } catch (error) {
            console.error("Error in okHandler:", error);
        }
    };

    useEffect(() => {
        let isMounted = true;  // Track if the component is still mounted

        const fetchData = async () => {
            try {
                await getStatus();

            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        // Cleanup function to prevent state update on unmounted component
        return () => {
            isMounted = false;
        };
    }, []);


    if (loading) {
        return (
            <Layout>
                <Container>
                    <Box mt={4} display="flex" justifyContent="center" alignItems="center" minHeight="80vh" >
                        <GridLoadingSpinner />
                    </Box>
                </Container>
            </Layout>
        );
    }

    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <Typography variant="h3" component="h1" gutterBottom>
                        Breakdown Management
                    </Typography>
                </Box> */}
                <Box mt={1} mb={2}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Breakdown Management" />
                </Box>
                <Box mb={2}>
                    <Typography variant="body1" style={{ fontSize: 'clamp(1rem, 1.5vw, 1.5rem)', fontWeight: 400 }}>
                        Select an option
                    </Typography>
                </Box>
                <Box mb={2}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={10} className='PM' onClick={() => handler('/breakdown-management/current-breakdowns')}>
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <PowerIcon />
                                            <p className='text'>
                                                Current Breakdowns
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item className='PM' xs={12} sm={10} onClick={() => handler('/breakdown-management/todays-breakdowns')}>
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <CalendarTodayIcon />
                                            <p className='text'>
                                                Today's Breakdown
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item className='PM' xs={12} sm={10} onClick={() => handler('/breakdown-management/pending-approvals')}>
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <CheckCircleIcon />
                                            <p className='text'>
                                                Approvals
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item className='PM' xs={12} sm={10} onClick={() => handler('/breakdown-management/pending-notes')} >
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }} >
                                            <AssignmentIcon />
                                            <p className='text'>
                                                Maintenance Notes
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item className='PM' xs={12} sm={10} onClick={() => handler('/breakdown-management/root-cause-analysis')}>
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <WbIncandescentIcon />
                                            <p className='text'>
                                                Root Cause Analysis
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item className='PM' xs={12} sm={10} onClick={() => { handler("/breakdown-management/break-down-logs") }}>
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <ViewHeadlineIcon />
                                            <p className='text'>
                                                Breakdown Logs
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                            {/* <Grid container spacing={4}>
                        <Grid item className='PM' xs={12} sm={10} >
                            <div className='breakdown-items'>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <CreateIcon className='MuiIcon-fontSizeLarge' />
                                    <p className='text'>
                                        Manual Timings
                                    </p>
                                </div>
                                <DoubleArrowIcon />
                            </div>
                        </Grid>
                    </Grid> */}
                            <Grid container spacing={2}>
                                <Grid item className='PM' xs={12} sm={10} onClick={() => { handler("/breakdown-management/bd-reports") }}>
                                    <div className='breakdown-items'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <ShowChartIcon />
                                            <p className='text'>
                                                Analytics
                                            </p>
                                        </div>
                                        <DoubleArrowIcon />
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box>
                                {/* <Typography
                                variant="h4"
                                gutterBottom
                                align="center"
                            >
                                Calendar View
                            </Typography> */}
                                <Box
                                    className="calendar-container"
                                    boxShadow={3}
                                    borderRadius={8}
                                    overflow="hidden"
                                >
                                    <FullCalendar
                                        plugins={[
                                            dayGridPlugin,
                                            timeGridPlugin,
                                            interactionPlugin,
                                        ]}
                                        initialView="dayGridMonth"
                                        headerToolbar={{
                                            left: 'prev,next today',
                                            center: 'title',
                                            right:
                                                'dayGridMonth,timeGridWeek,timeGridDay',
                                        }}
                                        buttonText={{
                                            today: 'Today',
                                            month: 'Month',
                                            week: 'Week',
                                            day: 'Day',
                                        }}
                                        events={allEvents}
                                        eventClick={handleEventClick}
                                        eventDisplay="list-item" // Enables a popover-like display on click
                                        // eventClick={(info) => {
                                        //     // FullCalendar shows a popover with event details automatically when using `list-item` display.
                                        //     info.jsEvent.preventDefault(); // Prevents the default navigation
                                        // }}
                                        // dateClick={handleDateClick}
                                        selectable={true}
                                        editable={true}
                                        height="auto"
                                    />.
                                    {/* Event Popover */}
                                    <Popover
                                        open={Boolean(anchorEl)}
                                        anchorEl={anchorEl}
                                        onClose={handleClosePopover}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                    >
                                        <Box p={2}>
                                            {selectedEvent && (
                                                <>
                                                    <Typography variant="h6">
                                                        {selectedEvent.title}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        Start: {selectedEvent.start.toLocaleString()}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        Asset No: {(selectedEvent.extendedProps.asset_no)?.slice(3) || "No Asset No available"}
                                                    </Typography>

                                                    {/* {selectedEvent.extendedProps && (
                                                    <Typography variant="body2">
                                                        Details: {selectedEvent.extendedProps.details || "No details available"}
                                                    </Typography>
                                                )} */}
                                                </>
                                            )}
                                        </Box>
                                    </Popover>
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>

                </Box>
            </Container>
        </Layout >
    );
};

export default Breakdown;
